<template>
	<div id="modal">
		<transition name="modal">
			<div class="modal__mask">
				<div class="modal__wrapper">
					<div class="modal__container">
						<div class="modal__header">
							<h1 class="h1">{{ modalMsg }}</h1>
						</div>
						<div class="modal__body">
							<p class="lead-text">{{ modalText }}</p>
						</div>
						<div class="modal__footer text-align--right">
							<button class="button button--tertiary" @click="$emit('close')">OK</button>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
	export default {
		name: 'contact-modal',
		data() {
			return {
				locale: 'ro',
				modalMsg: 'Va multumim!',
				modalText: 'Vom vom contacta in cel mai scurt timp.'
			};
		},
		created() {
			this.locale = document.documentElement.lang;
			if(this.locale === 'en') {
				this.modalMsg = 'Thank you!';
				this.modalText = 'We will contact you as soon as possible.';
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/js/vue/components/contact-modal.vue